module.exports = __webpack_public_path__ + "img/avatar4.878175ec.png";